import { apiConfigs } from "../../constants/apiConfigs"
import axiosClient from "../../utils/axiosClient"

export const registerDevice = async (deviceInfo: {device_id: string | number, device_type: string, device_model: string, platform: string, os_version: string, app_version: string, push_token: string}) => {
    const response = await axiosClient.post(apiConfigs.DEVICE_REGISTRATION.url, deviceInfo);
    return response.data;
}

export const checkLatestAppVersion = async (platform: string, app_version: string) => {
    const response = await axiosClient.post(apiConfigs.DEVICE_VERSION_CHECK.url, {platform, app_version});
    return response.data;
}